import { render, staticRenderFns } from "./CptsTransaction.vue?vue&type=template&id=35c72fb2"
import script from "./CptsTransaction.vue?vue&type=script&lang=js"
export * from "./CptsTransaction.vue?vue&type=script&lang=js"
import style0 from "./CptsTransaction.vue?vue&type=style&index=0&id=35c72fb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports